import {
  Routes,
  Route,
  useNavigate,
  useLocation,
  Navigate,
  Outlet,
  useParams,
} from "react-router-dom";
import { useEffect } from "react";

// components
import Layout from "../components/layout/Layout";
import FullScreenLayout from "../components/superAdminPanel/FullScreenLayout";
import UIKits from "../pages/UIKits";
import PaymentList from "../pages/paymentList/PaymentList";
import StoreSearch from "../pages/storeSearch";
import Category from "../pages/catrgory";
import ShoppingBaskets from "../components/common/shoppingBaskets/ShopingBaskets";
// import UserInformation from "../components/layout/userInformation/UserInformation";
// import ProfileList from "../pages/ProfileList";
// import Home from "../pages/Home";
import AddressManage from "../pages/AddressManage/Address";
import CheckOut from "../components/check-out/CheckOut";
import YourAddress from "../components/check-out/YourAddress";
import Home from "../pages/Home";
import AboutUs from "../pages/aboutUs/AboutUs";

import UserInformation from "../components/profile/userInformation/UserInformation";
import ProfileList from "../pages/profileList/ProfileList.jsx";

import ShopPage from "../pages/ShopPage/ShopPage";
import SingleProductPage from "../pages/SingleProductPage.jsx";
import OrdersPage from "../pages/OrdersPage";

import FilterProduct from "../pages/allFilterProduct/FilterProduct";
import SuperAdminPanel from "../pages/SuperAdminPanel";
import AdminPanel from "../pages/AdminPanel";
import AuthenticationContext from "../context/Authentication/AuthenticationContext";
import { useContext } from "react";
import Loader from "../components/superAdminPanel/utils/Loader";
import UploadPage from "../components/adminPanel/upload-page/UploadPage";
import UploadExcelLine from "../components/superAdminPanel/upload-line/UploadExcelLine";
import AvbUpload from "../components/superAdminPanel/upload-excel-avb/AvbUpload";
import BannerManagement from "../components/superAdminPanel/banner-management";
import ReactGA, { pageview } from "react-ga";
import VendorOrders from "../pages/VendorOrders";
import VendorLayout from "../components/layout/VendorLayout/VendorLayout";
import InfoFinancialPage from "../pages/InfoFinancialPage";
import ManagmentMenuPage from "../components/shops/ManagmentMenu";
import InfoProductPage from "../pages/InfoProductPage";
import ManagerProfile from "../components/vendorPanel/ManagerProfile/ManagerProfile";
import VendorShopInfo from "../components/vendorPanel/vendorShop/VendorShopInfo";
import ManagerInfo from "../components/vendorPanel/ManagerInfo/ManagerInfo";
import RequestedProducts from "../pages/requested-product/RequestedProducts";
import ShiftWork from "../components/vendorPanel/shiftwork/ShiftWork";
import AdminLogin from "../pages/AdminLogin";
export default function Router() {
  const route = useLocation();
  // sabadi
  const TRACKING_ID = "UA-235207325-1";
  // fazeli
  // const TRACKING_ID = "UA-263382959-1";
  ReactGA.initialize(TRACKING_ID);
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, [route.pathname]);
  return (
    <Routes>
      {/* test for sample of uis  */}
      <Route
        path="ui-kits"
        element={
          <ProtectedRoute>
            <Layout bottomNav={false}>
              <UIKits />
            </Layout>
          </ProtectedRoute>
        }
      />
      {/* publics  */}
      {/* home  */}
      <Route
        index
        path="/"
        element={
          <ProtectedRoute>
            <Layout bottomNav={true}>
              <Home />
            </Layout>
          </ProtectedRoute>
        }
      />
      {/* shopping cart  */}
      <Route
        index
        path="shopping-cart"
        element={
          <ProtectedRoute>
            <Layout bottomNav={true}>
              <ShoppingBaskets />
            </Layout>
          </ProtectedRoute>
        }
      />
      {/* orders  */}
      <Route
        index
        path="orders"
        element={
          <ProtectedRoute>
            <Layout bottomNav={true}>
              <OrdersPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* shop page  */}

      <Route
        index
        path="/shop/:shopId"
        element={
          <ProtectedRoute>
            <Layout bottomNav={false}>
              <ShopPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        index
        path="/product/:shopId/:productId"
        element={
          <ProtectedRoute>
            <Layout bottomNav={false}>
              <SingleProductPage />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* users  */}
      {/* list of payment for users  */}
      <Route
        index
        path="payment-list"
        element={
          <ProtectedRoute>
            <Layout bottomNav={false}>
              <PaymentList />
            </Layout>
          </ProtectedRoute>
        }
      />
      {/* user profile information */}
      <Route
        index
        path="profile-information"
        element={
          <ProtectedRoute>
            <Layout bottomNav={false}>
              <UserInformation />
            </Layout>
          </ProtectedRoute>
        }
      />
      {/* user profile */}
      <Route
        index
        path="user-profile"
        element={
          <ProtectedRoute>
            <Layout bottomNav={true}>
              <ProfileList />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* about sabadi  */}
      <Route
        index
        path="about-us"
        element={
          <ProtectedRoute>
            <Layout bottomNav={false}>
              <AboutUs />
            </Layout>
          </ProtectedRoute>
        }
      />
      {/* store search */}
      <Route
        index
        path="store-search/:storeId"
        element={
          <ProtectedRoute>
            <Layout bottomNav={false}>
              <StoreSearch />
            </Layout>
          </ProtectedRoute>
        }
      />
      {/*  A category */}
      <Route
        index
        path="category/:storeId/:lineId"
        // path="category"
        element={
          <ProtectedRoute>
            <Layout bottomNav={false}>
              <Category />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* address management  */}
      <Route
        index
        path="address-management"
        element={
          <ProtectedRoute>
            <Layout bottomNav={false}>
              <AddressManage />
            </Layout>
          </ProtectedRoute>
        }
      />
      {/*check out  */}
      <Route
        index
        path="check-out/:id/"
        element={
          <ProtectedRoute>
            <Layout bottomNav={false}>
              <CheckOut />
            </Layout>
          </ProtectedRoute>
        }
      />
      {/*your address  */}
      <Route
        index
        path="your-address/:id"
        element={
          <ProtectedRoute>
            <Layout bottomNav={false}>
              <YourAddress />
            </Layout>
          </ProtectedRoute>
        }
      />
      {/*filter product*/}
      <Route
        index
        path="filter-product/:shopId/:title/:index"
        element={
          <ProtectedRoute>
            <Layout bottomNav={false}>
              <FilterProduct />
            </Layout>
          </ProtectedRoute>
        }
      />
      {/* super admin  */}
      <Route
        path="super-admin-panel/upload-excel"
        element={
          <ProtectedRoute>
            <UploadPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="super-admin-panel/upload-lines"
        element={
          <ProtectedRoute>
            <UploadExcelLine />
          </ProtectedRoute>
        }
      />
      <Route
        path="super-admin-panel/upload-avb-product"
        element={
          <ProtectedRoute>
            <AvbUpload />
          </ProtectedRoute>
        }
      />
      <Route
        path="super-admin-panel/banner-management"
        element={
          <ProtectedRoute>
            <BannerManagement />
          </ProtectedRoute>
        }
      />
      <Route
        path="super-admin-panel"
        element={
          <ProtectedRoute>
            <FullScreenLayout>
              <SuperAdminPanel />
            </FullScreenLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="admin-panel/login"
        element={
          <ProtectedRoute>
            <FullScreenLayout>
              <AdminLogin />
            </FullScreenLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="admin-panel/:supplier_id"
        element={
          <ProtectedRoute>
            <FullScreenLayout>
              <AdminPanel />
            </FullScreenLayout>
          </ProtectedRoute>
        }
      />
      {/* vendor Routes  */}
      <Route
        path="vendor-panel/orders"
        element={
          <VendorLayout bottomNav={true}>
            <VendorOrders />
          </VendorLayout>
        }
      />
      {/* managment-menu */}
      <Route
        index
        path="managment-menu"
        element={
          <VendorLayout bottomNav={true}>
            <ManagmentMenuPage />{" "}
          </VendorLayout>
        }
      />
      {/* info-Financial */}
      <Route
        index
        path="info-Financial"
        element={
          <VendorLayout bottomNav={true}>
            <InfoFinancialPage />{" "}
          </VendorLayout>
        }
      />
      <Route
        index
        path="vendor-panel/manager-profile"
        element={
          <VendorLayout bottomNav={true}>
            <ManagerProfile />
          </VendorLayout>
        }
      />
      <Route
        index
        path="vendor-panel/manager-info"
        element={
          <VendorLayout bottomNav={false}>
            <ManagerInfo />
          </VendorLayout>
        }
      />
      <Route
        index
        path="product-info"
        element={
          <VendorLayout bottomNav={true}>
            <InfoProductPage />
          </VendorLayout>
        }
      />
      <Route
        path="vendor-panel/shop-info"
        element={
          <VendorLayout bottomNav={false}>
            <VendorShopInfo />
          </VendorLayout>
        }
      />
      <Route
        path="vendor-panel/shift-work"
        element={
          <VendorLayout bottomNav={false}>
            <ShiftWork />
          </VendorLayout>
        }
      />
    </Routes>
  );
}

function ProtectedRoute({ children }) {
  const { userInfo, isLogin, isChecked } = useContext(AuthenticationContext);
  const route = useLocation();
  const params = useParams();

  if (!isChecked) {
    return <Loader />;
  }

  let flag = true;
  if (isLogin) {
    if (route.pathname.includes("/customer-panel")) {
      flag = true;
    } else if (route.pathname.includes("/admin-panel")) {
      flag = false;
      if (
        userInfo.access_level.isSuperAdmin ||
        userInfo.access_level.supplierList.find(
          (c) => c.id === params.supplier_id
        )
      ) {
        flag = true;
      }
    } else if (userInfo.access_level.isSuperAdmin) {
      // flag = false;
      // if (
      //   route.pathname.includes("/super-admin-panel") ||
      //   route.pathname.includes("/admin-panel")
      // ) {
      flag = true;
      // }
    }
  }

  if (flag === true) {
    return children ? children : <Outlet />;
  }

  if (isLogin && userInfo.access_level.isSuperAdmin) {
    return <Navigate to="/super-admin-panel" replace />;
  }
  return <Navigate to="/" replace />;
}
